import { create } from 'zustand';
import { AppModule } from '@estimator/shared';

interface ModuleState {
  activeModule: AppModule;
  setActiveModule: (module: AppModule) => void;
}

const STORAGE_KEY = 'v2erp-active-module';

function getPersistedModule(): AppModule {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && Object.values(AppModule).includes(stored as AppModule)) {
      return stored as AppModule;
    }
  } catch {}
  return AppModule.ESTIMATION;
}

export const useModuleStore = create<ModuleState>((set) => ({
  activeModule: getPersistedModule(),
  setActiveModule: (module) => {
    localStorage.setItem(STORAGE_KEY, module);
    set({ activeModule: module });
  },
}));
